import React from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'formik';

const MyTextField = props => {
	const [field, meta] = useField(props);
	return (
		<TextField
			{...field}
			{...props}
			error={meta.touched && meta.error ? true : false}
			helperText={meta.touched && meta.error ? meta.error : null}
		/>
	);
};

export default MyTextField;
